import type { ActionButton } from '@app/src/components/ActionButtons'
import useAiScreeningEnabled from '@app/src/hooks/useAiScreeningEnabled'
import { sendNewIntercomMessage } from '@app/src/hooks/intercom'
import useOrganizationSettings from '@app/src/hooks/useOrganizationSettings'
import { insertIf } from '@app/src/utils/helpersTs'
import AddIcon from '@mui/icons-material/Add'
import { Stack } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'
import ConfigurationCollection from '../../ConfigurationCollection'
import AiScreeningEmptyState from './AiScreeningEmptyState'
import AiScreeningSettings from './AiScreeningSettings'
import AiScreeningToggle from './AiScreeningToggle'

const AiScreeningInfoPage: React.FC = () => {
  const { formatMessage } = useIntl()
  const { isFetched } = useOrganizationSettings()
  const isAiScreeningEnabled = useAiScreeningEnabled()

  const handleAddCreditsClick = () => {
    const message = `${formatMessage({ id: 'aiScreening.intercomMessage.firstLineText' })}\n\n${formatMessage({
      id: 'aiScreening.intercomMessage.secondLineText',
    })}`
    sendNewIntercomMessage(message)
  }

  return (
    <ConfigurationCollection
      actionButtons={insertIf<ActionButton>(isAiScreeningEnabled, {
        label: formatMessage({ id: 'aiScreening.actionButtons.addCredits' }),
        onClick: handleAddCreditsClick,
        startIcon: <AddIcon />,
        variant: 'contained',
      })}
    >
      <Stack mr={4} spacing={4}>
        <AiScreeningToggle />
        {isAiScreeningEnabled ? <AiScreeningSettings /> : isFetched && <AiScreeningEmptyState />}
      </Stack>
    </ConfigurationCollection>
  )
}

export default AiScreeningInfoPage
